export default "__VITE_ASSET__CN8C9sus__"